import React from 'react'
import "./header.css"
import people from "../../assets/people.png"
import Ai from "../../assets/ai.png"


const Header = () => {
  return (
    <div className="gpt3__header section__padding" id='Home'>
      <div className="gpt3__header-content">
        <h1 className="gradient__text">
          Let’s Build Something
          amazing with GPT-3 OpenAI
        </h1>
        <p>OpenAI has quickly become one of the biggest names in tech. The artificial intelligence (AI) company has made realistic image generators, 3D-model creators and, the thing it is now best-known for, ChatGPT.</p>

        <div className="gpt3__header-content-input">
          <input type="email" placeholder='Your Email Address'/>
          <button type='button'>Get Started</button>
        </div>

        <div className="gpt3__header-content-people">

          <img src={people} alt="people" />
          <p>1,600 people requested access a visit in last 24 hours</p>
        </div>

      </div>
        
      <div className="gpt3__header-image">
        <img src={Ai} alt="Ai" />
      </div>

    </div>
  )
}

export default Header